export default __webpack_public_path__ + "static/media/dark-garden.b36a4914.png";